import { gql } from "@apollo/client";

/** Card fields shared across listings */
export const JOB_CARD_FIELDS = `
  id
  title
  description
  employmentType
  location
  payMin
  payMax
  payUnit
  applicationsCount
  publishedAt
  expiresAt        # <-- added
  createdAt
  isActive
  business {
    id
    name
    url
    address
  }
`;

/** (Optional) Use this when you want includeExpired=true for provider views */
export const GET_JOB_POSTINGS = gql`
  query GetJobPostings($businessId: ID!, $includeExpired: Boolean = false) {
    getJobPostings(businessId: $businessId, includeExpired: $includeExpired) {
      ${JOB_CARD_FIELDS}
    }
  }
`;

export const GET_JOB_POSTINGS_BY_BUSINESS = gql`
  query JobPostingsByBusiness(
    $businessId: ID!
    $onlyActive: Boolean
    $limit: Int
    $offset: Int
  ) {
    jobPostingsByBusiness(
      businessId: $businessId
      onlyActive: $onlyActive
      limit: $limit
      offset: $offset
    ) {
      ${JOB_CARD_FIELDS}
    }
  }
`;

export const GET_JOB_POSTING = gql`
  query GetJobPosting($id: ID!) {
    jobPosting(id: $id) {
      id
      businessId
      title
      description
      employmentType
      schedule
      location
      payMin
      payMax
      payUnit
      isActive
      publishedAt
      expiresAt        # <-- added
      createdAt
      updatedAt
      applicationsCount
      business {
        id
        name
        url
        address
      }
    }
  }
`;

export const GET_JOB_APPLICATIONS_BY_JOB = gql`
  query JobApplicationsByJob(
    $jobId: ID!
    $status: JobApplicationStatus
    $limit: Int
    $offset: Int
  ) {
    jobApplicationsByJob(
      jobId: $jobId
      status: $status
      limit: $limit
      offset: $offset
    ) {
      id
      applicantName
      applicantEmail
      applicantPhone
      resumeUrl
      coverLetter
      status
      createdAt
      updatedAt
      job {
        id
        title
      }
    }
  }
`;

/** ✅ Remove the legacy `category: ADULT_FAMILY_HOME` version.
 *  Use the ID-based version below everywhere. */
export const GET_AFH_JOB_POSTINGS_BY_CATEGORY_ID = gql`
  query GetAfhJobPostingsByCategoryId(
    $categoryId: ID!
    $onlyActive: Boolean!
    $limit: Int!
    $offset: Int!
  ) {
    jobPostingsByCategory(
      categoryId: $categoryId
      onlyActive: $onlyActive
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        ${JOB_CARD_FIELDS}
      }
    }
  }
`;

export const GET_SAVED_JOB_IDS = gql`
  query MySavedJobIds($limit: Int = 1000) {
    mySavedJobs(limit: $limit) {
      id
      __typename
    }
  }
`;
  

/** ✅ businessesWithOpenJobsByCategory only supports (categoryId, q, limit, offset).
 *  Remove city/state/zip from variables and selection. */
export const GET_BUSINESSES_WITH_OPEN_JOBS = gql`
  query BusinessesWithOpenJobsByCategory(
    $categoryId: ID!
    $q: String
    $limit: Int = 50
    $offset: Int = 0
  ) {
    businessesWithOpenJobsByCategory(
      categoryId: $categoryId
      q: $q
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        id
        name
        url
        address
        jobCount
      }
    }
  }
`;

/** Same as above, trimmed to schema */
export const GET_AFH_BIZ_WITH_OPEN_JOBS = gql`
  query AfhBizWithJobs(
    $categoryId: ID!
    $q: String
    $limit: Int
    $offset: Int
  ) {
    businessesWithOpenJobsByCategory(
      categoryId: $categoryId
      q: $q
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        id
        name
        url
        address
        jobCount
      }
    }
  }
`;

export const MY_JOB_APPS = gql`
  query MyJobApps($limit: Int = 50, $offset: Int = 0) {
    myJobApplications(limit: $limit, offset: $offset) {
      id
      jobId
      status
      createdAt
      updatedAt
      applicantName
      applicantEmail
      applicantPhone
      coverLetter
      resumeUrl
      job {
        ${JOB_CARD_FIELDS}
      }
    }
  }
`;

export const MY_SAVED_JOBS = gql`
  query MySavedJobs($limit: Int, $offset: Int) {
    mySavedJobs(limit: $limit, offset: $offset) {
      ${JOB_CARD_FIELDS}
    }
  }
`;
export const MY_CANDIDATE_PROFILE = gql`
  query MyCandidateProfile {
    myCandidateProfile {
      userId
      openToWork
      headline
      phone
      resume {                
      url
      name
      updatedAt
    }
      defaultCoverLetter
      qualifications
      updatedAt
    }
  }
`;
